import { render, staticRenderFns } from "./ctHz.vue?vue&type=template&id=40548e2c&scoped=true"
import script from "./ctHz.vue?vue&type=script&lang=js"
export * from "./ctHz.vue?vue&type=script&lang=js"
import style0 from "./ctHz.vue?vue&type=style&index=0&id=40548e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40548e2c",
  null
  
)

export default component.exports